import { useLayoutContext } from '../../../context/layoutContext'
import type { SpecialCaseComponentProps } from '../types'
import { useSpecialCasedSubTemplatedFieldVariant } from '../useSpecialCasedSubTemplatedFieldVariant'
import { CcCalcStepFieldPriority } from './CcCalcStepFieldPriority'

export const CcCalcStepFieldType = ({ data }: SpecialCaseComponentProps) => {
  const {
    preferences: {
      templates: { isShowingSimplifiedView },
    },
  } = useLayoutContext()
  const variant = useSpecialCasedSubTemplatedFieldVariant(data)
  const ccStepType =
    variant?.modelType?.typeName === 'CcCalcStepSubGroup'
      ? 'Group'
      : variant?.modelType?.typeName.match(/CcCalc(?<type>\w+)(Step|SubGroup)/)
          ?.groups?.['type']

  return (
    <div className="h-full flex! flex-col justify-center">
      <div className="pl-4">{ccStepType ?? '-'}</div>
      {isShowingSimplifiedView && <CcCalcStepFieldPriority variant={variant} />}
    </div>
  )
}
